import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TourPackagesFilters } from "~/features/packages-tour/components/tour-packages-filters";
import { TourPackagesList } from "~/features/packages-tour/components/tour-packages-list";

export const Route = createFileRoute("/packages/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <div className="ekv:w-full ekv:max-w-6xl ekv:mx-auto ekv:py-8 ekv:p-4">
      <h1 className="ekv:text-2xl ekv:font-bold ekv:mb-4">Tour Packages</h1>
      <div className="ekv:grid ekv:md:grid-cols-[300px_1fr] ekv:gap-4">
        <TourPackagesFilters />
        <TourPackagesList
          onViewClick={(item) => {
            navigate({
              to: `/packages/${item.id}/`,
              search: {
                startRatePax: item.start_rate_pax,
                startRate: item.start_rate,
              },
            });
          }}
        />
      </div>
    </div>
  );
}
